export default function Marquee({ items, dark = true, label = 'Trades we work with' }) {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-heading text-sm font-bold uppercase tracking-[0.18em] sm:text-base ${
              dark ? 'text-offwhite/80' : 'text-charcoal/70'
            }`}
          >
            {item}
          </span>
          <span className="h-2.5 w-2.5 bg-lime" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`overflow-hidden border-y py-5 ${dark ? 'border-charcoal-line bg-charcoal-deep' : 'border-hairline bg-white'}`}
      data-testid="trade-marquee"
    >
      <span className="sr-only">{label}: {items.join(', ')}</span>
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
